var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        data: _vm.pageData.patientList,
        border: "",
        stripe: "",
        height: "100%",
        "highlight-current-row": true,
        "header-cell-style": {
          backgroundColor: "#F2F3F5",
          color: "#1D2129",
          borderColor: "#E5E6EB",
        },
      },
      on: { "row-click": _vm.rowClick },
    },
    [
      _c("el-table-column", {
        attrs: { prop: "name", label: "名称", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "contactPhone", label: "手机号", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "birthDate", label: "生日", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "stateSign", label: "状态", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("el-tag", [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("STATUS_CODE_MAP")(scope.row.stateSign)) +
                      " "
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "storeUserName", label: "挂号医生", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "enrollTime", label: "挂号时间", align: "center" },
      }),
      _c("el-table-column", {
        attrs: { prop: "name", label: "操作", align: "center" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.cancel(scope.row)
                      },
                    },
                  },
                  [_vm._v("退诊")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }